import { ensureString } from 'ensure-string';

export function readCSV(csv) {
  csv = ensureString(csv);
  const lines = csv.split('\n');
  const headers = lines.shift().split(',');
  const variables = headers.map((h) => ({ label: h, data: [] }));
  for (const line of lines) {
    const values = line.split(',');
    for (let i = 0; i < variables.length; i++) {
      variables[i].data.push(Number(values[i]));
    }
  }
  return variables;
}
